import { render, staticRenderFns } from "./BackgroundColorLink.vue?vue&type=template&id=60276060&scoped=true&"
import script from "./BackgroundColorLink.vue?vue&type=script&lang=js&"
export * from "./BackgroundColorLink.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColorLink.vue?vue&type=style&index=0&id=60276060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60276060",
  null
  
)

export default component.exports